import {
  FETCH_BOOKMARK_LOADING,
  FETCH_BOOKMARK_DONE,
  FETCH_BOOKMARK_ERROR,
  FETCH_BOOKMARK_DETAILS_DONE,
  FETCH_BOOKMARK_DETAILS_ERROR,
  FETCH_BOOKMARK_DETAILS_LOADING,
  POST_DATA_TEMP,
  POST_BOOKMARK_LOADING,
  POST_BOOKMARK_DONE,
  POST_BOOKMARK_ERROR,
  DELETE_BOOKMARK_LOADING,
  DELETE_BOOKMARK_DONE,
  DELETE_BOOKMARK_ERROR
} from './actions'

export default {
  [FETCH_BOOKMARK_LOADING] (state) {
    state.isLoading = true
  },

  [FETCH_BOOKMARK_DONE] (state, bookmark) {
    state.bookmark = bookmark
    state.isLoading = false
  },

  [FETCH_BOOKMARK_ERROR] (state, error) {
    state.error = error
    state.isLoading = false
  },

  [FETCH_BOOKMARK_DETAILS_LOADING] (state) {
    state.isLoadingBookmarkDetails = true
    state.isErrorBookmarkDetails = false
  },

  [FETCH_BOOKMARK_DETAILS_DONE] (state, items) {
    state.bookmarkDetails = items
    state.isLoadingBookmarkDetails = false
    state.isErrorBookmarkDetails = false
  },

  [FETCH_BOOKMARK_DETAILS_ERROR] (state, error) {
    state.isErrorBookmarkDetails = true
    state.isLoadingBookmarkDetails = false
    state.bookmarkDetails = []
  },

  [POST_DATA_TEMP] (state, items) {
    state.dataTemp = items
  },

  [POST_BOOKMARK_LOADING] (state) {
    state.isLoadingPostBookmark = true
    state.isErrorPostBookmark = false
  },

  [POST_BOOKMARK_DONE] (state, items) {
    state.postBookmark = items
    state.isLoadingPostBookmark = false
    state.isErrorPostBookmark = false
  },

  [POST_BOOKMARK_ERROR] (state, error) {
    state.isErrorPostBookmark = true
    state.isLoadingPostBookmark = false
    state.postBookmark = []
  },

  [DELETE_BOOKMARK_LOADING] (state) {
    state.isLoadingDeleteBookmark = true
    state.errorDeleteBookmark = false
  },

  [DELETE_BOOKMARK_DONE] (state, items) {
    state.deleteBookmark = items
    state.isLoadingDeleteBookmark = false
    state.errorDeleteBookmark = false
  },

  [DELETE_BOOKMARK_ERROR] (state, error) {
    state.errorDeleteBookmark = error
    state.isLoadingDeleteBookmark = false
    state.deleteBookmark = {}
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/bookmark/mutations.js